export default __webpack_public_path__ + "static/media/logo-ilhabela-negativo.52f45637.png";